const eventsGroups = {
  android: 'androidEvents',
  ios: 'iosEvents',
  "": 'customEvents'
}

const eventsTypes = {
  click: 'click',
  download: 'download',
  version: 'version'
}

const eventsNames = {
  docsClicked: 'docsClicked',
  downloadClicked: 'downloadClicked',
  faqClicked: 'faqClicked',
  changelogClicked: 'changelogClicked'
}

export class PiwikClass {
  static sendEvent(eventGroup, eventType, eventName) {
    try {
      _paq.push(['trackEvent', eventGroup, eventType, eventName])
    } catch (e) {
      console.error('No piwik variable found')
    }
  }

  static sendDocsClickedEvent (device) {
    PiwikClass.sendEvent(eventsGroups[device], eventsTypes.click, eventsNames.docsClicked)
  }

  static sendDownloadClickedEvent (device) {
    PiwikClass.sendEvent(eventsGroups[device], eventsTypes.click, eventsNames.downloadClicked)
  }

  static sendFaqClickedEvent (device) {
    PiwikClass.sendEvent(eventsGroups[device], eventsTypes.click, eventsNames.faqClicked)
  }

  static sendChangelogClickedEvent (device) {
    PiwikClass.sendEvent(eventsGroups[device], eventsTypes.click, eventsNames.changelogClicked)
  }

  static sendDownloadEvent (fileName, device) {
    PiwikClass.sendEvent(eventsGroups[device], eventsTypes.download, fileName)
  }

  static sendVersionEvent (version, device) {
    PiwikClass.sendEvent(eventsGroups[device], eventsTypes.version, version)
  }
}
